import React from 'react';
import ThirdPartyScriptsWrapper from 'apps/thirdPartyScripts/containers/ThirdPartyScriptsWrapper';
import DynamicYieldLoader from './DynamicYieldApiLoader';

export default function DynamicYieldApiLoaderWrapper({ isDynamicYieldEnabled }) {
  return (
    <ThirdPartyScriptsWrapper>
      <DynamicYieldLoader isDynamicYieldEnabled={isDynamicYieldEnabled} />
    </ThirdPartyScriptsWrapper>
  );
}
